import { sireSubTabs } from './tabNames';

const checkSubTabSelected = tab =>
    (tab ? Object.values(sireSubTabs).some(arr => arr.includes(tab)) : true);

export default checkSubTabSelected;



// WEBPACK FOOTER //
// ./src/js/shared/nav/helpers/checkSubTabSelected.js